import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { PageHeader } from 'components/page-header';
import { pageTitle } from 'utils/page-title';
import RoyaltyChecksContent from './royalty-checks-content';
import {
  AddDocumentSidePanel,
  DocumentUploadConfig,
} from 'components/add-document-modal/add-document-side-panel';

const ROYALTY_CHECK_UPLOAD_CONFIG: DocumentUploadConfig = {
  documentType: 'royalty_check',
  promptCategory: 'royalty_check_document_fields',
  accept: ['.pdf', '.csv', '.xml'],
  uploadHelperText: 'Upload a single PDF, CSV, or XML file (max 500 MB limit)',
  promptHelperText: 'For royalty check documents',
  idPrefix: 'rc-',
  errorFallback: 'Problem uploading royalty check document',
};

const RoyaltyChecksListPage: FC = () => {
  return (
    <>
      <Helmet>
        <title>{pageTitle('Royalty Checks')}</title>
      </Helmet>
      <PageHeader
        breadcrumbs={[]}
        title="Royalty Checks"
        actions={
          <AddDocumentSidePanel
            triggerLabel="Add Royalty Check"
            title="Add Royalty Check"
            subtitle="Upload a royalty check document to begin processing."
            config={ROYALTY_CHECK_UPLOAD_CONFIG}
          />
        }
      />
      <RoyaltyChecksContent />
    </>
  );
};

export { RoyaltyChecksListPage };
